import moment from 'moment';

export default function getUsersAge(birth) {
    return moment(birth).isValid() ? moment().diff(birth, 'years') : '';
}